import { ArticleHeading4, ArticleHeading5 } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { formatPhoneNumber } from '../../utils/formatPhoneNumber';

interface IPhoneNumbers {
  phone: string;
  narrow?: boolean;
}

export const PhoneNumber = ({ phone, narrow }: IPhoneNumbers) => {
  const Heading = narrow ? ArticleHeading5 : ArticleHeading4;

  return (
    <div className={cn(styles['phone-number'], narrow && styles['narrow'])}>
      <Heading as="p">{formatPhoneNumber(phone)}</Heading>
    </div>
  );
};
